<template>
  <div class="pa-4">
    <div class="font-weight-medium text-subtitle-2">
      {{ $t("admin.lblAnonymityFeedbackInfo") }}
    </div>
    <v-radio-group v-model="selectedAnonymity" @change="onSelectionChange">
      <v-radio
        v-for="(column, index) in setting.columns"
        :key="`Anonymity_${index}`"
        :value="column.value"
      >
        <template #label>
          <div class="subtitle-2">
            <b>{{ $t(`admin.${column.label}`) }}</b>
          </div>
        </template>
      </v-radio>
    </v-radio-group>
    <message-sheet
      v-if="displayMessage"
      :showMessage="displayMessage"
      :message="message"
      :messageType="messageType"
      @close="displayMessage = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MessageSheet from "../MessageSheet.vue";
import { createUUID } from "/src/utils/util";

export default {
  components: { MessageSheet },
  name: "AnonymityFeedback",
  props: {
    screenHeight: {
      type: Number,
      default: 250,
    },
    setting: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedAnonymity: "anonymous",
      displayMessage: false,
      messageType: "",
      message: "",
    };
  },
  computed: {
    ...mapGetters({
      tenantSettingConfig: "tenant/tenantSettingConfig",
      tenantSettingTypes: "tenant/tenantSettingTypes",
    }),
    LoaderText() {
      return this.$t("LoaderText");
    },
    tenantId() {
      return localStorage.getItem("tenantId");
    },
    locale() {
      return this.$i18n.locale;
    },
  },
  mounted() {
    this.setSelectedData();
  },
  methods: {
    ...mapActions({
      updateTenantConfig: "tenant/updateTenantConfig",
      createTenantConfig: "tenant/createTenantConfig",
    }),
    updateConfiguration,
    onSelectionChange,
    setSelectedData,
  },
};

async function setSelectedData() {
  try {
    if (!this.setting) return;

    const results = this.tenantSettingTypes(this.setting.configname);
    this.selectedAnonymity = results.length
      ? results
      : this.setting.columns[0].value;
  } catch (error) {
    console.error("API error:", error);
  }
}

async function onSelectionChange(value) {
  await this.updateConfiguration(value);
}

async function updateConfiguration(value) {
  try {
    const tenantConfig = this.tenantSettingConfig(this.setting.configname);
    const isExistingConfig = tenantConfig && tenantConfig.id;

    const setting = {
      id: isExistingConfig ? tenantConfig.id : createUUID(),
      tenantid: isExistingConfig ? tenantConfig.tenantid : this.tenantId,
      configname: this.setting.configname,
      [this.setting.configname]: isExistingConfig
        ? value
        : this.selectedAnonymity,
    };

    await (isExistingConfig
      ? this.updateTenantConfig(setting)
      : this.createTenantConfig(setting));

    this.displayMessage = true;
    this.messageType = "success";
    this.message = this.$t("admin.updateTenantConfigMsg");
  } catch (error) {
    console.error("API error:", error);
  }
}
</script>

<style>
</style>